export var TableMoreInfoTabKeys = {
    TableDetails: "tableDetails",
    TableRounds: "tableRounds",
    OnlineTableView: "onlineTableView",
    Edit: "edit",
};
export var TableMoreInfoTabs = function (tableName, t) { return [
    {
        label: tableName + " " + t("tableManagement.moreInfoDrawer.tabs.tableDetails"),
        key: TableMoreInfoTabKeys.TableDetails,
    },
    {
        label: t("tableManagement.moreInfoDrawer.tabs.tableRounds"),
        key: TableMoreInfoTabKeys.TableRounds,
    },
    {
        label: t("tableManagement.moreInfoDrawer.tabs.onlineTableView"),
        key: TableMoreInfoTabKeys.OnlineTableView,
    },
]; };
